module.exports = __webpack_public_path__ + "img/courses-thumb.adf9adeb.jpg";